@defer (when filteredCompanyList()) {
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-8" data-testid="landing-recent-research-grid">
    @for (company of displayedCompanies(); track company) {
      <app-company-grid-highlight-tile class="h-full" [company]="company"></app-company-grid-highlight-tile>
    }
  </div>
  @if (linkToAllStocks) {
    <div class="container mx-auto px-16 max-w-(--breakpoint-2xl) flex">
      <a class="mx-auto" [routerLink]="['/all-stocks']">
        <button class="mx-auto mt-5 text-gray-muted tracking-widest uppercase text-base font-medium">
          Show all companies <span><i class="fas fa-arrow-right"></i></span>
        </button>
      </a>
    </div>
  } @else {
    @if (shouldShowToggle()) {
      <div class="flex">
        <button
          class="mx-auto mt-4 text-gray-muted tracking-widest uppercase text-base font-medium"
          (click)="toggleCompanyDisplay()">
          @if (!showAllCompanies()) {
            <span>show all recent updates ({{ remainingCompanies() }} more)</span>
            <i class="fas fa-arrow-down"></i>
          } @else {
            <span>show less</span>
            <i class="fas fa-arrow-up"></i>
          }
        </button>
      </div>
    }
  }
} @placeholder {
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
    @for (item of [1, 2, 3, 4, 5, 6]; track item) {
      <div class="bg-gray-100 flex h-full animate-pulse">
        <div class="w-full lg:w-1/2 px-8 pb-8 pt-4 grid grid-cols-2">
          <div class="col-span-2 flex justify-between">
            <div class="h-5 w-32 bg-gray-200 rounded-sm"></div>
            <div class="h-4 w-6 bg-gray-200 rounded-sm"></div>
          </div>
          <div class="col-span-1 pt-2">
            <div class="h-4 w-16 bg-gray-200 rounded-sm"></div>
          </div>
          <div class="col-span-1">
            <div class="text-right space-y-2">
              <div class="h-4 w-20 bg-gray-200 rounded-sm ml-auto"></div>
              <div class="h-4 w-16 bg-gray-200 rounded-sm ml-auto"></div>
              <div class="h-4 w-12 bg-gray-200 rounded-sm ml-auto"></div>
            </div>
          </div>
          <div class="col-span-2 space-y-2">
            <div class="h-3 w-24 bg-gray-200 rounded-sm"></div>
            <div class="h-3 w-full bg-gray-200 rounded-sm"></div>
          </div>
        </div>
        <div class="hidden lg:flex w-1/2 border-t border-b border-l">
          <div class="h-full w-full bg-gray-200"></div>
        </div>
      </div>
    }
  </div>
}
